import React, { useEffect, useState } from "react";
import { API_URL } from "../../constant";
import axiosInstance from "../../utils/axiosConfig";
import { FaTimesCircle } from "react-icons/fa";
import CopyToClipboard from "react-copy-to-clipboard";
import { formatAmount } from "../../utils/FormatPerson";
import { resolveBankNameFromLists } from "../../lib/api/bankNameResolver";
import DocumentLightbox from "../../components/DocumentLightbox";
import { downloadRemoteFiles } from "../../lib/downloadRemoteFile";
interface Bank {
  accountNumber: string;
  bankCode: string;
  accountName: string;
  isDefault: boolean;
  _id: string;
}
const GiftcardModal = ({
  setOrderModal,
  userId,
  user,
  currencyUSD,
  currencyNGN,
  status,
  date,
  imageURL,
  cardType,
  txnId,
  setConfirmed,
  confirmed,
  ecode,
  setConfirmedModal,
}: any) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [banks, setBanks] = useState<Bank | null>(null);
  const [copyMail, setCopyMail] = useState<boolean>(false);
  const [copyAccount, setCopyAccount] = useState<boolean>(false);
  const [copyAmount, setCopyAmount] = useState<boolean>(false);
  const [allBanks, setAllBanks] = useState<any[]>([]);
  const [viewerUrls, setViewerUrls] = useState<string[]>([]);
  const [allOldBanks, setAllOldBanks] = useState<any[]>([]);

  useEffect(() => {
    if (user && typeof user === "object") {
      setEmail(user?.email?.address ?? "");
      setFirstName(user?.profile?.firstName ?? "");
      setLastName(user?.profile?.lastName ?? "");
      const bankList: Bank[] = Array.isArray(user?.banks) ? user.banks : [];
      const defaultBank =
        bankList.find((bank: Bank) => bank.isDefault) || bankList[0] || null;
      setBanks(defaultBank);
      return;
    }
    setEmail("");
    setFirstName("");
    setLastName("");
    setBanks(null);
  }, [user]);

  useEffect(() => {
    Promise.all([
      axiosInstance.get(`${API_URL}api/banks/palmpay`),
      axiosInstance.get(`${API_URL}api/banks`),
    ])
      .then(([palmpayRes, oldRes]: any[]) => {
        setAllBanks(
          Array.isArray(palmpayRes?.data?.data) ? palmpayRes.data.data : []
        );
        setAllOldBanks(
          Array.isArray(oldRes?.data?.data) ? oldRes.data.data : []
        );
      })
      .catch((e: any) => {
        console.log(e?.response?.data?.message);
      });
  }, []);

  useEffect(() => {
    if (status === "COMPLETED") {
      setConfirmed(true);
    } else {
      setConfirmed(false);
    }
  }, [status]);

  /** Signs each proof image so it can be rendered, then opens the viewer. */
  const viewImages = async (images: any[]) => {
    const signed: string[] = [];
    for (const image of images ?? []) {
      try {
        const response = await axiosInstance.post(
          `${API_URL}api/gift-cards-transactions/images/request-download-url`,
          { objectURL: image }
        );
        signed.push(response.data.data.signedURL);
      } catch (error: any) {
        console.log(error.response?.data?.message);
      }
    }
    if (signed.length > 0) setViewerUrls(signed);
  };

  /** Signs each proof image and saves it to disk. */
  const downloadImages = async (images: any[]) => {
    const signed: string[] = [];
    for (const image of images ?? []) {
      try {
        const response = await axiosInstance.post(
          `${API_URL}api/gift-cards-transactions/images/request-download-url`,
          { objectURL: image }
        );
        signed.push(response.data.data.signedURL);
      } catch (error: any) {
        console.log(error.response?.data?.message);
      }
    }

    if (signed.length === 0) return;

    const saved = await downloadRemoteFiles(signed, `giftcard-proof-${txnId}`);
    if (saved === 0) {
      // Storage isn't sending CORS headers for this origin, so the bytes can't
      // be read. Show the images instead of failing silently.
      setViewerUrls(signed);
    }
  };

  return (
    <div className="fixed inset-0 flex font-manrope justify-center items-start overflow-auto pt-16 pb-16  bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="w-11/12 mds:w-10/12 lgss:w-2/5 transition-all px-8 pt-8 ease-in duration-1000 pb-6 rounded-xl bg-[#0D0D0D] ">
        <div className="flex  pt-4 justify-between items-center">
          <h4 className="font-bold text-[20px] font-sora text-white">
            New giftcard order review
          </h4>
          <FaTimesCircle
            onClick={() => setOrderModal((prev: any) => !prev)}
            className="text-white text-[32px] cursor-pointer"
          />
        </div>
        <div className="w-full flex-col mt-12 justify-center   items-center ">
          <h4 className="text-[48px] text-[#DEE1E6] text-center font-bold font-sora ">
            ${formatAmount(currencyUSD)}
          </h4>
          <h4 className="text-[24px] text-[#DEE1E6] text-center font-bold font-sora ">
            {firstName} {lastName}
          </h4>
        </div>

        <div className="w-full h-[1px] bg-[#AEBCC6] mt-8 mb-4" />
        <div className="w-full mt-2 flex justify-between gap-4 items-center">
          <h4 className="text-[#AEBCC6] text-[16px] font-semibold">
            {ecode ? "E-code" : "File"}
          </h4>
          {ecode ? (
            <h4 className="text-[#869AA9]  font-bold text-[13px] ">{ecode}</h4>
          ) : (
            <div className="flex justify-center items-center gap-2">
              <button
                onClick={() => downloadImages(imageURL)}
                className="text-[#869AA9] flex items-center justify-center"
              >
                Download
              </button>
              <div className="w-[4px] h-[4px] rounded-full bg-[#869AA9]" />
              <button
                onClick={() => viewImages(imageURL)}
                className="text-[#60B7F6] flex items-center justify-center"
              >
                View
              </button>
            </div>
          )}
        </div>
        <div className="w-full mt-2 flex justify-between items-center">
          <h4 className="text-[#AEBCC6] text-[16px] font-semibold">
            Card (Country)
          </h4>
          <h4 className="text-[#869AA9] font-bold text-[16px] ">
            {cardType.country
              ? `${cardType.country}(${cardType.card.name})`
              : `${cardType.card.name}(${cardType.card.country.name})`}
          </h4>
        </div>
        <div className="w-full mt-2 flex justify-between items-center">
          <h4 className="text-[#AEBCC6] text-[16px] font-semibold">
            Recipient address
          </h4>
          <CopyToClipboard
            text={email}
            onCopy={() => {
              setCopyMail(true);
              setTimeout(() => {
                setCopyMail(false);
              }, 3000);
            }}
          >
            {copyMail ? (
              <h4 className="text-[12px] xs:text-[14px] text-[#869AA9]">
                Copied
              </h4>
            ) : (
              <h4 className="text-[#0C84DA] text-[14px] cursor-pointer ">
                {email}
              </h4>
            )}
          </CopyToClipboard>
        </div>
        <div className="w-full mt-2 flex justify-between items-center">
          <h4 className="text-[#AEBCC6] text-[16px] font-semibold">
            Amount to pay
          </h4>
          <CopyToClipboard
            text={currencyNGN}
            onCopy={() => {
              setCopyAmount(true);
              setTimeout(() => {
                setCopyAmount(false);
              }, 3000);
            }}
          >
            {copyAmount ? (
              <h4 className="text-[12px] xs:text-[14px] text-[#869AA9]">
                Copied
              </h4>
            ) : (
              <h4 className="text-[#869AA9] text-[16px] cursor-pointer">
                ₦{formatAmount(currencyNGN)}
              </h4>
            )}
          </CopyToClipboard>
        </div>
        <div className="w-full mt-2 flex justify-between items-center">
          <h4 className="text-[#AEBCC6] text-[16px] font-semibold">
            Cash destination
          </h4>
          <CopyToClipboard
            text={banks ? banks?.accountNumber : ""}
            onCopy={() => {
              setCopyAccount(true);
              setTimeout(() => {
                setCopyAccount(false);
              }, 3000);
            }}
          >
            {copyAccount ? (
              <h4 className="text-[12px] xs:text-[14px] text-[#869AA9]">
                Copied
              </h4>
            ) : (
              <div className="text-[#0C84DA] cursor-pointer flex gap-2 justify-center items-center font-bold text-[13px] ">
                {banks && banks.accountNumber}{" "}
                <h5 className="text-[#869AA9]">
                  {resolveBankNameFromLists(
                    banks?.bankCode,
                    allBanks,
                    allOldBanks
                  )}
                </h5>
              </div>
            )}
          </CopyToClipboard>
        </div>
        <div className="w-full mt-2 flex justify-between items-center">
          <h4 className="text-[#AEBCC6] text-[16px] font-semibold">Status</h4>
          <h4
            className={
              status === "PENDING"
                ? "text-[#CB9200] flex justify-center items-center w-[90px] bg-[#181818] tracking-wider h-[26px] rounded-full text-[11px] font-bold"
                : status === "IN PROGRESS"
                ? "text-[#60B7F6] flex justify-center items-center w-[90px] bg-[#181818] tracking-wider h-[26px] rounded-full text-[11px] font-bold"
                : status === "COMPLETED"
                ? "text-[#03C668] flex justify-center items-center w-[90px] bg-[#0E2B1F] tracking-wider h-[26px] rounded-full text-[11px] font-bold"
                : ""
            }
          >
            {status}
          </h4>
        </div>
        <div className="w-full mt-2 flex justify-between items-center">
          <h4 className="text-[#AEBCC6] text-[16px] font-semibold">Date</h4>
          <h4 className="text-[#869AA9] text-[16px] ">{date}</h4>
        </div>
        <div className="flex flex-col w-full  mt-8">
          {!confirmed && (
            <button
              onClick={() => {
                setConfirmedModal((prev: any) => !prev);
                setOrderModal((prev: any) => !prev);
              }}
              className="flex justify-center items-center h-[47px] rounded-lg bg-[#0B84CB] text-white font-medium "
            >
              Confirm transaction
            </button>
          )}
          <a
            href={`mailto:${email}`}
            className="flex justify-center items-center h-[47px] mt-8 rounded-lg border bg-transparent border-[#0B84CB] text-white font-medium "
          >
            Contact the client
          </a>
        </div>
      </div>

      {viewerUrls.length > 0 && (
        <DocumentLightbox
          urls={viewerUrls}
          title="Proof of payment"
          onClose={() => setViewerUrls([])}
        />
      )}
    </div>
  );
};

export default GiftcardModal;
